module.exports = __webpack_public_path__ + "images/Topic Portal Background.svg";